module.exports = __webpack_public_path__ + "resources/img/img_experdb.036fa3d664e8967272852f5a9cf5f45b.png";